import ApiService from "../../../../../../services/ApiService";
import translate from "../../../../../../services/Translate";
import { TutorFormPayload } from "./TutorFormModal.d";

export const fetchUserTutorredCohortSkillBlocks = (
  userId: number,
  cohortId: number,
  language: string,
  setSkillBlocks: Function,
  setLoading: Function
) => {
  setLoading(true);

  ApiService.get(`users/${userId}/tutors/cohorts/${cohortId}/skill-blocks`)
    .then((response) => setSkillBlocks(response.data.cohort_skill_blocks))
    .catch((error) => {
      console.error("An error occurred while fetching user's cohort skill blocks", error);
      alert(translate(language, "PAGES.USER.TUTOR.SKILL_BLOCK_FORM.ERROR"));
    })
    .finally(() => setLoading(false));
};

export const saveUserTutorredCohortForm = (
  userId: number,
  cohortId: number,
  payload: TutorFormPayload,
  language: string,
  setSaving: Function,
  onSubmitted: Function
) => {
  setSaving(true);

  ApiService.post(`users/${userId}/tutors/cohorts/${cohortId}/forms`, payload)
    .then(() => {
      alert(translate(language, "PAGES.USER.TUTOR.SKILL_BLOCK_FORM.SUCCESS"));
      onSubmitted();
    })
    .catch((error) => {
      console.error("An error occurred while saving user's tutoring form", error);
      alert(translate(language, "PAGES.USER.TUTOR.SKILL_BLOCK_FORM.SAVE_ERROR"));
    })
    .finally(() => setSaving(false));
};
